module.exports = __webpack_public_path__ + "img/logo.d1bc06a7.png";